/**
 * @file コンポーネント：フル動画ページ決済情報ボタン DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import { StyledButton, StyledButtonIcon, StyledButtonText } from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    return (
        <StyledButton onClick={(e) => props.fnOnClickButtonPayment(e)}>
            <StyledButtonIcon>
                <i className="fas fa-yen-sign"></i>
            </StyledButtonIcon>
            <StyledButtonText>
                {localized["Label.PaymentMenu"]}
            </StyledButtonText>
        </StyledButton>
    );
};
